import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { PagesGestioneAnagraficaCreaAnagraficaComponent } from "./crea-anagrafica/crea-anagrafica.component";
import { PagesGestioneAnagraficaRicercaAnagraficaComponent } from "./ricerca-anagrafica/ricerca-anagrafica.component";
import { PagesGestioneAnagraficaModificaAnagraficaComponent } from "./modifica-anagrafica/modifica-anagrafica.component";

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: "inserisci",
        component: PagesGestioneAnagraficaCreaAnagraficaComponent,
      },
      {
        path: "ricerca",
        component: PagesGestioneAnagraficaRicercaAnagraficaComponent,
      },
      {
        path: "modifica",
        component: PagesGestioneAnagraficaModificaAnagraficaComponent,
      },
    ]),
  ],
  exports: [RouterModule],
})
export class PagesGestioneAnagraficaRoutingModule {}
